module.exports = __webpack_public_path__ + "static/media/hbonow.0c29134f.png";